import { OrderStatus } from 'interfaces';

export const isBeforeToPayStatus = (orderStatus: OrderStatus) =>
   orderStatus === 'DELIVERED' || orderStatus === 'WAITING' || orderStatus === 'IN_PROGRESS';
